// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1__a6a147cad5dd9ca02627","cls2":"WinBackPing-cls2___0cb65ed46221bfeef58 WinBackPing-cls1__a6a147cad5dd9ca02627"};